import { makeStyles } from '@material-ui/core/styles';
import { MenuStyleProps } from './index.types';

export default ({drawerOpen, drawerWidth, isSmallScreen}: MenuStyleProps) => {
    const useStyles = makeStyles((theme) => {
        return {
          drawer: {
            width: drawerOpen ? theme.spacing(25) + 1 : theme.spacing(25),
              flexShrink: 0,
              overflowX: 'hidden',
              whiteSpace: 'nowrap',
              transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              [theme.breakpoints.down('xs')]: {
                width: 0,
              },
              color: '#fff',
          },
          drawerPaper: {
            width: drawerOpen ? theme.spacing(25) + 1 : theme.spacing(25),
              overflowX: 'hidden',
              whiteSpace: 'nowrap',
              transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              [theme.breakpoints.down('xs')]: {
                width: drawerOpen ? theme.spacing(30) + 1 : 0,
              },
              backgroundColor: '#003C70',
          },
          logoutContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingTop: 20,
            paddingRight: 20
          },
          logoutIcon: {
            transform: 'rotateY(180deg)',
          },
          menuContainer: {
            marginTop: 30,
            height: 'calc(100vh - 150px)'
          },
          drawerContainer: {
              overflow: 'auto',
          },
          menuCloseIcon: {
              display: 'flex',
              justifyContent: drawerOpen ? 'flex-end' : 'center',
              alignContent: 'center'
          },
          linkText: {
            textDecoration: 'none',
            color: '#fff'
          },
          drop:{
            background:"#ffffff",
            width:"240px",
            height:"35px",
            paddingLeft:"10px",
            paddingRight:"10px",
            marginLeft:"8px",
            borderRadius:"6px",
            marginTop:"3px",
            color:"#112B42",
            fontSize: 14
        },
          listIcon: {
            minWidth: '40px',
            color: '#fff'
          },
          activeLink: {
            '& .bt': {
              backgroundColor: '#104E84'
            }
          }
    }});
    return useStyles;
}